import { ModalFooter } from "@hostingbv/lib/src/components/layout/ModalProvider";
import { FC, useCallback, useState } from "react";
import { config } from "../config";
import { useApiClient } from "@hostingbv/lib/src/api";
import { Input } from "@hostingbv/lib/src/components/form/Input";
import { Autocomplete } from "@hostingbv/lib/src/components/form/Autocomplete";
import countries from 'i18n-iso-countries'
import { useNavigate } from "react-router-dom";


export const AddCustomerModal: FC = () => {
  const countryOptions = countries.getNames('en')
  const { partnerClient } = useApiClient(config)
  const navigate = useNavigate()

  const [name, setName] = useState('')
  const [street, setStreet] = useState('')
  const [number, setNumber] = useState('')
  const [zip, setZip] = useState('')
  const [city, setCity] = useState('')
  const [country, setCountry] = useState('NL')
  const [referenceNumber, setReferenceNumber] = useState('')
  const [error, setError] = useState('')

  const save = useCallback(async () => {
    await partnerClient.createCustomer({
      display_name: name,
      address_street: street,
      address_number: number,
      address_zip: zip,
      address_city: city,
      address_country: country,
      ...(referenceNumber === "" ? {} : { reference_number: referenceNumber }),
    }).then(result => {
      if (!result.success) {
        setError(result.error)
        throw new Error(result.error)
      } else {
        navigate(`/customers/${result.data.id}`)
      }
    })
  }, [name, street, number, zip, city, country, referenceNumber])

  return <>
    <form onSubmit={() => save()} className={"space-y-4 flex-1"}>
      <div className={"flex items-center max-w-md space-x-4"}>
        <Input label={"Name"} type={"text"} value={name} onChange={(v) => setName(v)} />
      </div>
      <div className={"flex items-center max-w-md space-x-4"}>
        <Input label={"Street"} type={"text"} value={street} onChange={(v) => setStreet(v)} />
        <Input label={"Number"} type={"text"} value={number} onChange={(v) => setNumber(v)} />
      </div>
      <div className={"flex items-center max-w-md space-x-4"}>
        <Input label={"Zipcode"} type={"text"} value={zip} onChange={(v) => setZip(v)} />
        <Input label={"City"} type={"text"} value={city} onChange={(v) => setCity(v)} />
      </div>
      <div className={"flex items-center max-w-md space-x-4"}>
        <Autocomplete label={"Country"} value={country} options={countryOptions} onChange={(v) => setCountry(v)} />
      </div>
      <div className={"flex items-center max-w-md space-x-4"}>
        <Input label={"Reference number (optional)"} type={"text"} value={referenceNumber} onChange={(v) => setReferenceNumber(v)} />
      </div>
      {error.length > 0 && <div className={"font-medium text-red-600"}>
        {error}
      </div>}
    </form>
    <ModalFooter text={"Save"} onSubmit={save} />
  </>
}
